module.exports = __webpack_public_path__ + "static/media/directions.a5f9a6ae.svg";